


























import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import { Fragment } from 'vue-fragment';

import FaqCard from './FaqCard.vue';
import Scroll from '@/components/scroll/InfiniteScrollBox.vue';
import ContactFooter from '@/components/footer/ContactFooter.vue';

import { ArticleData } from '@/model/faq';
import FaqMixin from '@/mixins/faq';
import store from '@/store';
import { namespace } from 'vuex-class';

const authModule = namespace('auth');
@Component({
  components: {
    ContactFooter,
    Fragment,
    FaqCard,
    Scroll
  }
})
export default class FaqSection extends Mixins(FaqMixin) {
  @Prop({ required: true })
  title!: string;

  @Prop({ required: true })
  list!: ArticleData[] | null;

  @Prop({ required: false, default: null })
  id!: number | string | null;

  @Prop({ required: false, default: false })
  noFooter!: boolean;

  @authModule.Getter('isLoggedIn')
  isLoggedIn!: boolean;

  isLoadingArticle = false;
  hasNext: string | null = null;

  created() {
    this.hasNext = this.nextPageRecord[this.id as string];
  }

  beforeUpdate() {
    if (this.search === '') {
      this.hasNext = this.nextPageRecord[this.id as string];
    } else {
      this.hasNext = this.nextPageRecord['searched'];
    }
  }

  async loadNextPage() {
    await store.dispatch('nextPage');
    if (this.id !== 'searched') {
      store.dispatch('fetchCategorizedArticles', this.id);
    } else {
      store.dispatch('fetchQueriedArticles', {
        query: this.search,
        section: this.id !== 'searched' ? this.id : undefined
      });
    }
  }

  handleCategoryClick(item: ArticleData) {
    // Push state to a new category articles page
    const id = item.id;
    if (!(id in this.idMap)) {
      store.dispatch('setCurrentArticle', item);
    }
    this.$router.push({
      name: id in this.idMap ? 'faq-section' : 'faq-article-body',
      params: {
        id: id.toString()
      }
    });
  }
}
